/**
 * Shared client config for portal's axios client and the generated (@billda/api)
 * client. One definition of baseUrl / clientType / appVersion so axiosClient.ts
 * and billdaApi.ts can't drift apart.
 */
export const baseUrl =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:6550';
export const portalGatewayBaseUrl =
  import.meta.env.VITE_PORTAL_GATEWAY_BASE_URL || baseUrl;
export const clientType = 'portal' as const;
export const appVersion = import.meta.env.VITE_APP_VERSION;
